<script lang="ts">
  let { text = undefined, offsetX = undefined }: { text?: string; offsetX?: string } = $props();
</script>

<oc-skip-link-v1 style:--oc-skip-link-v1-offset-x={offsetX}>
  <oc-button-v1 variant="secondary" size={/*      */ "50"} icon-type-left="skip-link">
    {text
      ? `Es folgt eine lange Liste. ${text} überspringen`
      : "Es folgt eine lange Liste. Überspringen"}
  </oc-button-v1>
</oc-skip-link-v1>

<style>
  oc-skip-link-v1:not(:defined) {
    display: none;
  }
</style>
